import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
import TFoot from './TFoot';

interface IProps {
  moduleData: any;
  handleDelete: any;
  setModuleData: any;
  isView: boolean;
  machineData: any;
}

const TController = ({
  moduleData,
  isView,
  handleDelete,
  setModuleData,
  machineData,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            isView,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            handleDelete,
            machineData,
          }}
        />
        <TFoot moduleData={moduleData} />
      </RenderTable>
    </Box>
  );
};

export default TController;
